const text = `
<div class="block">
    <h2>• Проводной интернет (кабель или оптоволокно)</h2>
    <div class="subblock">
        <h3>Плюсы:</h3>
        <ul>
            <li>
                - Стабильная и высокая скорость
            </li>
            <li>
                - Независимость от погодных условий
            </li>
        </ul>
    </div>
    <div class="subblock">
        <h3>Минусы:</h3>
        <ul>
            <li>
                - Не везде есть техническая возможность подключить
            </li>
            <li>
                - Высокая стоимость подключения, включая кабель
            </li>
            <li>
                - Требуется дополнительное оконечное оборудование
            </li>
            <li>
                - Абонентская плата значительно выше, чем в городе
            </li>
            <li>
                - Долгое реагирование техподдержки и обслуживания оборудования
            </li>
        </ul>
    </div>
    <div class="subblock">
        <h3>Стоимость:</h3>
        <ul>
            <li>
                Абонентская плата от 800р/мес
            </li>
        </ul>
    </div>
</div>
<div class="block">
    <h2>• Спутниковый интернет</h2>
    <div class="subblock">
        <h3>Плюсы:</h3>
        <ul>
            <li>
                - Интернет практически в любой точке земного шара
            </li>
        </ul>
    </div>
    <div class="subblock">
        <h3>Минусы:</h3>
        <ul>
            <li>
                - Очень высокая стоимость подключения и оборудования
            </li>
            <li>
                - Низкая скорость передачи данных
            </li>
            <li>
                - Высокая зависимость от погодных условий
            </li>
            <li>
                - Высокая абонентская плата
            </li>
        </ul>
    </div>
    <div class="subblock">
        <h3>Стоимость:</h3>
        <ul>
            <li>
                Абонентская плата от 3500р/мес
            </li>
        </ul>
    </div>
</div>
<div class="block">
    <h2>• Мобильный интернет через USB модем</h2>
    <div class="subblock">
        <h3>Плюсы:</h3>
        <ul>
            <li>
                - Достаточно бюджетное решение
            </li>
            <li>
                - Быстрое подключение
            </li>
            <li>
                - Самостоятельное подключение
            </li>
        </ul>
    </div>
    <div class="subblock">
        <h3>Минусы:</h3>
        <ul>
            <li>
                - Стабилен в непосредственной близости от вышки сотового оператора
            </li>
            <li>
                - Заранее неизвестна стабильность работы
            </li>
            <li>
                - Затратно подбирать оборудование
            </li>
            <li>
                - Риск перегруженности вышки количеством абонентов
            </li>
            <li>
                - Высокая абонентская плата на безлимитных тарифах
            </li>
        </ul>
    </div>
    <div class="subblock">
        <h3>Стоимость:</h3>
        <ul>
            <li>
                От 2800р (за модем), безлимит с ограничением скорости от 900-1200р/мес
            </li>
        </ul>
    </div>
</div>
<div class="block">
    <div class="starBlock">
        <span class="icon24 icon-star_to_provider_0"></span>
        <h2 class="low-margin">Интернет «под ключ» через дилера оператора связи </h2>
    </div>
        <p>
            Это комплексное решение подключения загородного дома по сети LTE, с установкой в доме сети Wi-Fi
        </p>
        <div class="subblock">
            <h3>Плюсы:</h3>
            <ul>
                <li>
                    - Подключение на следующий день после заявки
                </li>
                <li>
                    - Сравнительно низкая абонентская плата за полностью безлимитный тариф (часто у дилера есть эксклюзивные тарифы от оператора)
                </li>
                <li>
                    - Тестируется разное оборудование на лучший прием сигнала, подключение при хорошем результате
                </li>
                <li>
                    - Техподдержка 24/7
                </li>
                <li>
                    - При переезде возможность взять оборудование с собой
                </li>
            </ul>
        </div>
        <div class="subblock">
            <h3>Минусы:</h3>
            <ul>
                <li>
                    - Относительно высокая стоимость подключения
                </li>
            </ul>
        </div>
        <div class="subblock">
            <h3>Стоимость:</h3>
            <ul>
                <li>
                    От 12000р комплект оборудования с установкой; безлимитный тариф от 400р/мес
                </li>
            </ul>
        </div>
    </div>
`;

export default text;
